import { useSecondaryMenu } from 'ui/components/BPLayout'

import { useHRRContext } from '../../context'

export const SideBar = () => {
  const { data } = useHRRContext()
  const { bankAccounts, showQuestionnaireDemo, showQuestionnaire1 } = data
  const enableQuestionnaire = showQuestionnaireDemo || showQuestionnaire1

  const items = [
    { label: 'General Information', hash: 'general' },
    ...bankAccounts.map((_, index) => ({ label: `Bank Account ${index + 1}`, hash: `bank-account-${index}` })),
    ...(enableQuestionnaire ? [{ label: 'Red Flags', hash: 'red_flags' }] : []),
    { label: 'Uploaded Files', hash: 'uploaded_files' },
    { label: 'History', hash: 'history' }
  ]

  useSecondaryMenu(items)

  return null
}
